import { getClient } from '@zg-rentals/ts-client-http-client';

export const httpClient = getClient().extend({
  prefixUrl: process.env.NEXT_PUBLIC_RENTAL_PREFIX_URL,
});

export const rentalManagerHttpClient = getClient().extend({
  prefixUrl: process.env.NEXT_PUBLIC_RENTAL_MANAGER_PREFIX_URL,
});
